import { CloseOutlined, Verified } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import React, { useEffect } from "react";
import { Link, useRefresh } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import LinkToBankProducts from "../partners/LinkToBankProducts";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import CustomSelect from "../unit/forms/CustomSelect";
import useNotify from "../unit/useNotify";
import VerticalSpacer from "../unit/VerticalSpacer";
import Spacer from "../unit/Spacer";

const CounselorsAdd = (props: any) => {
  const refresh = useRefresh();
  const id = 99999;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  const [showSubmit, setShowSubmit] = React.useState(false);
  const [counselorId, setCounselorId] = React.useState(false);
  const [checkedProductArr, setCheckedProductArr] = React.useState([]);
  const counselorList = props?.counselorList;
  const productList = props?.productList;

  useEffect(() => {
    if (counselorId && checkedProductArr) {
      setShowSubmit(true);
    } else {
      setShowSubmit(false);
    }
  }, [counselorId, checkedProductArr]);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setCounselorId(0);
    refresh();
  };

  let counselorShowList = [];
  if (counselorList) {
    counselorShowList = counselorList.map((item: any) => {
      return {
        value: item.id,
        label: item.sName,
      };
    });
  }
  return (
    <>
      <Button
        onClick={handleOpen}
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "auto",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Select Counselor
      </Button>
      <Dialog
        className="counselors_add_dialog"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            let formJson = Object.fromEntries((formData as any).entries());
            let select_products: any[] = [];
            let select = document.querySelectorAll(
              ".counselors_add_dialog .partners_select_product"
            );
            select.forEach((element) => {
              if ((element as HTMLInputElement)?.checked) {
                select_products.push((element as HTMLInputElement)?.value);
              }
            });
            formJson.productId = select_products.join(",");

            const reqUrl = `counselors/actions/add`;
            const response = await sendRequest(reqUrl, {
              id: "new",
              data: formJson,
            });
            if (response && response.code == "200") {
              successNotify("Data saved successfully");
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Select Counselor
          <IconButton
            style={{ position: "absolute", right: "10px", top: "10px" }}
            onClick={handleClose}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              pt: 1,
              height: "50vh",
              maxHeight: "50vh",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: "bold",
                color: "grey",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              Step 1: Select Counselor
            </Typography>
            <Typography sx={{ mb: 1, color: "gray" }}>
              If you cannot find the counseling agency, your partner has not
              registered on Happy Mango. Ask your partner to create an account
              through this link:
              <Link
                to="https://advisor.happymangocredit.com/user/register"
                target="_blank"
                rel="noopener"
                style={{ marginLeft: "5px" }}
              >
                https://advisor.happymangocredit.com/user/register
              </Link>
            </Typography>
            <CustomSelect
              variant="outlined"
              source="counselorId"
              name="counselorId"
              value={counselorId}
              optionlist={counselorShowList}
              onChange={(event) => {
                setCounselorId(event.target.value);
              }}
              validate={[]}
              fullWidth
            />
            <Box sx={{ height: "20px" }}></Box>
            <LinkToBankProducts
              productList={productList}
              title={`Step 2: Select Products`}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          {showSubmit && <CustomButtonSubmit label="Add" />}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CounselorsAdd;
